<template>
  <div
    v-if="showPoweredBy"
    class="octadesk-app-powered-by"
    :class="{
      'conversation-offset': inConversationRoute,
      'reset--z-index conversation': inConversationRoute,
      'kb-enabled': showKbCard
    }"
  >
    <a :href="poweredByLink" target="_system">
      <svg viewBox="0 0 111 111" width="111" height="111">
        <use xlink:href="#octa-logo" />
      </svg>

      <span class="poweredBy">{{ $t('poweredBy') }}</span>
    </a>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters([
        'active',
        'showKbCard',
        'culture',
        'company',
        'whitelabel',
        'showFooterPoweredBy'
      ]),
      showPoweredBy() {
        return this.active && !this.whitelabel && this.showFooterPoweredBy
      },
      inConversationRoute() {
        return this.$route && this.$route.path === '/conversation'
      },
      poweredByLink() {
        return 'https://www.octadesk.com/powered-by-octadesk'
      }
    }
  }
</script>

<style lang="scss">
  .conversation-offset {
    margin-top: 60px;
  }

  .octadesk-app-powered-by {
    width: calc(100% - 26px);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 0px;
    position: fixed;
    z-index: 3;
    bottom: 0;
    background: #f7f7f7;
    left: 10px;
    padding-left: 6px;
    right: 16px;

    a {
      text-decoration: none;

      span {
        color: #cacaca;
        font-family: Helvetical, Arial;
        font-size: 11px;
      }

      svg {
        width: 18px;
        height: 18px;
        fill: #b9b9b9;
        margin-right: 8px;
      }
    }
    &.conversation:not(.kb-enabled) {
      position: relative;
      padding: 10px 0px;
      background: transparent;
    }
  }
</style>
